import type { NotificationType } from "@/types/inbox.types";

export const filterOptions: { value: NotificationType | "all"; label: string }[] = [
  { value: "all", label: "All types" },
  { value: "document", label: "Documents" },
  { value: "contract", label: "Contracts" },
  { value: "deal", label: "Deals" },
];

export const defaultTypeOrder: NotificationType[] = ["contract", "document", "deal"];
